export default "__VITE_ASSET__Dwoir4PA__"